import { Grid } from "@material-ui/core";
import { Switch, Route, Redirect } from "react-router-dom";

// Components
import Questionnaire from "../questionnaire/Questionnaire";

// Styles
import SharedStyle from "../../assets/styles/materialUI/global/SharedStyle";

const MainContainer = () => {
	const classes = SharedStyle();

	return (
		<Grid className={classes.systemContainer}>
			<Switch>
				<Route path="/questionnaire" component={Questionnaire} />
				<Route path="/">
					<Redirect to="/questionnaire/login" />
				</Route>
			</Switch>
		</Grid>
	);
};

export default MainContainer;
